
import Vue from "vue";

export default Vue.extend({
  name: "SettlementSummaryCard",
  props: {
    title: { type: String, required: true },
    notice: { type: String, default: "" },
  },
});
